module.exports = __webpack_public_path__ + "static/media/main2Mobile.a1577c44.svg";